import { COLORS, LAYOUT } from '../../constants';

export const styles = {
  // Page Container
  pageContainer: {
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.background} 0%, #fdf5f6 100%)`,
    paddingBottom: LAYOUT.spacing.xxxl
  },

  // Header
  header: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #9d0d1d 100%)`,
    padding: `${LAYOUT.spacing.xxl}px ${LAYOUT.spacing.lg}px ${LAYOUT.spacing.xxxl}px ${LAYOUT.spacing.lg}px`,
    marginBottom: LAYOUT.spacing.xxl,
    boxShadow: `0 4px 20px ${COLORS.primary}30`,
    position: 'relative'
  },

  backButton: {
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.xs,
    background: 'transparent',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 500,
    marginBottom: LAYOUT.spacing.md,
    padding: `${LAYOUT.spacing.xs}px ${LAYOUT.spacing.sm}px`,
    borderRadius: LAYOUT.borderRadius.md,
    transition: 'all 0.2s ease'
  },

  backText: {
    color: 'white'
  },

  headerTitle: {
    fontSize: 42,
    fontWeight: 800,
    color: 'white',
    margin: 0,
    marginBottom: LAYOUT.spacing.sm,
    textAlign: 'center',
    letterSpacing: 1
  },

  headerSubtitle: {
    fontSize: 18,
    color: 'rgba(255, 255, 255, 0.9)',
    margin: 0,
    textAlign: 'center',
    fontWeight: 400,
    paddingBottom: LAYOUT.spacing.sm
  },

  // Content Container
  contentContainer: {
    maxWidth: 720,
    margin: '0 auto',
    padding: `0 ${LAYOUT.spacing.lg}px`
  },

  form: {
    background: COLORS.white,
    borderRadius: LAYOUT.borderRadius.lg,
    padding: LAYOUT.spacing.xxl,
    boxShadow: `0 4px 24px ${COLORS.primary}15`,
    border: `1px solid ${COLORS.lightGray}`
  },

  // Photo Section
  photoSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: LAYOUT.spacing.xxl,
    paddingBottom: LAYOUT.spacing.xl,
    borderBottom: `2px solid ${COLORS.lightGray}`
  },

  photoContainer: {
    position: 'relative',
    marginBottom: LAYOUT.spacing.md
  },

  profilePhoto: {
    width: 140,
    height: 140,
    borderRadius: '50%',
    objectFit: 'cover',
    border: `4px solid ${COLORS.primary}`,
    boxShadow: `0 4px 16px ${COLORS.primary}30`
  },

  photoPlaceholder: {
    width: 140,
    height: 140,
    borderRadius: '50%',
    background: `${COLORS.primary}10`,
    border: `4px solid ${COLORS.primary}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  changePhotoButton: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 44,
    height: 44,
    borderRadius: '50%',
    background: COLORS.primary,
    border: `3px solid white`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: `0 2px 12px ${COLORS.primary}50`,
    transition: 'all 0.2s ease'
  },

  hiddenFileInput: {
    display: 'none'
  },

  photoHint: {
    fontSize: 14,
    color: COLORS.darkGray,
    margin: 0,
    textAlign: 'center'
  },

  // Form Fields
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.lg
  },

  fieldGroup: {
    display: 'flex',
    flexDirection: 'column'
  },

  label: {
    fontSize: 16,
    fontWeight: 600,
    color: COLORS.primary,
    marginBottom: LAYOUT.spacing.xs
  },

  required: {
    color: COLORS.primary,
    marginLeft: 4
  },

  input: {
    width: '100%',
    padding: '14px 16px',
    fontSize: 16,
    border: `2px solid ${COLORS.mediumGray}`,
    borderRadius: LAYOUT.borderRadius.md,
    outline: 'none',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
    fontFamily: 'inherit'
  },

  inputDisabled: {
    width: '100%',
    padding: '14px 16px',
    fontSize: 16,
    border: `2px solid ${COLORS.lightGray}`,
    borderRadius: LAYOUT.borderRadius.md,
    background: COLORS.background,
    color: COLORS.darkGray,
    cursor: 'not-allowed',
    boxSizing: 'border-box',
    fontFamily: 'inherit'
  },

  textarea: {
    width: '100%',
    padding: '14px 16px',
    fontSize: 16,
    border: `2px solid ${COLORS.mediumGray}`,
    borderRadius: LAYOUT.borderRadius.md,
    outline: 'none',
    transition: 'all 0.2s ease',
    resize: 'vertical',
    minHeight: 100,
    boxSizing: 'border-box',
    fontFamily: 'inherit'
  },

  fieldHint: {
    fontSize: 13,
    color: COLORS.darkGray,
    marginTop: LAYOUT.spacing.xs,
    margin: `${LAYOUT.spacing.xs}px 0 0 0`
  },

  // Actions
  actionsContainer: {
    marginTop: LAYOUT.spacing.xxl,
    paddingTop: LAYOUT.spacing.xl,
    borderTop: `2px solid ${COLORS.lightGray}`,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: LAYOUT.spacing.md
  },

  cancelButton: {
    padding: '14px 32px',
    fontSize: 16,
    fontWeight: 600,
    background: 'white',
    color: COLORS.darkGray,
    border: `2px solid ${COLORS.mediumGray}`,
    borderRadius: LAYOUT.borderRadius.md,
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },

  saveButton: {
    padding: '14px 32px',
    fontSize: 16,
    fontWeight: 600,
    background: COLORS.primary,
    color: 'white',
    border: 'none',
    borderRadius: LAYOUT.borderRadius.md,
    cursor: 'pointer',
    boxShadow: `0 4px 12px ${COLORS.primary}30`,
    transition: 'all 0.2s ease',
    letterSpacing: 0.5
  },

  saveButtonDisabled: {
    padding: '14px 32px',
    fontSize: 16,
    fontWeight: 600,
    background: COLORS.mediumGray,
    color: 'white',
    border: 'none',
    borderRadius: LAYOUT.borderRadius.md,
    cursor: 'not-allowed',
    opacity: 0.6
  }
};